import { Avatar, Button, ButtonProps, Stack, Typography } from '@mui/material';
import { raiseUnreachable } from '@vy/utils';
import { VySwitch } from '../../../../../../../../components/new-design/inputs/VySwitch';
import {
  RenewContractOption,
  RENEW_CONTRACT_OPTIONS,
} from '../renew-contract-dialog-types/renew-contract-option';

type RenewContractStepOptionButtonProps = {
  option: RenewContractOption;
  onSelect: (option: RenewContractOption) => void;
  icon: React.ReactNode;
  avatarBackground: string;
  description: string;
  isAutoRenewalChecked?: boolean;
  isSelected?: boolean;
} & ButtonProps;

export const RenewContractStepOptionButton: React.FC<RenewContractStepOptionButtonProps> = ({
  option,
  onSelect,
  icon,
  avatarBackground,
  description,
  isAutoRenewalChecked,
  isSelected = false,
  ...props
}) => {
  const isAutoRenewalOption = option === RENEW_CONTRACT_OPTIONS.Auto;

  return (
    <Button
      onClick={() => onSelect(option)}
      {...props}
      sx={{
        display: 'flex',
        width: '216px',
        height: '187px',
        padding: '32px 48px',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '8px',
        border: isSelected ? '2px solid #5EA3EF' : '1px solid #E8EBF2',
        background: isSelected ? '#E7F2FF' : '#FFF',
        '&:hover': {
          background: '#E7F2FF',
        },
        '&:active': {
          border: '2px solid #5EA3EF',
        },
      }}
    >
      <Stack
        direction="column"
        sx={{
          alignItems: "center",
          gap: 1
        }}>
        <Avatar sx={{ width: 62, height: 62, bgcolor: avatarBackground }}>{icon}</Avatar>

        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1,
            justifyContent: "center"
          }}>
          <Typography
            sx={{
              lineHeight: "24px",
              textAlign: "center",
              fontWeight: "600",
              fontStyle: 'normal',
              fontSize: 14,
              color: 'black'
            }}>
            {getOptionLabel(option)}
          </Typography>

          {isAutoRenewalOption && <VySwitch checked={isAutoRenewalChecked} />}
        </Stack>

        <Typography
          sx={{
            textAlign: "center",
            fontSize: 12,
            color: '#7E8796',
            lineHeight: '16px',
            width: '196px'
          }}>
          {description}
        </Typography>
      </Stack>
    </Button>
  );
};

function getOptionLabel(option: RenewContractOption) {
  switch (option) {
    case RENEW_CONTRACT_OPTIONS.Auto:
      return 'Auto-renew';
    case RENEW_CONTRACT_OPTIONS.SameTerms:
      return 'Update terms & Renew ';
    case RENEW_CONTRACT_OPTIONS.NewTerms:
      return 'Create a new contract';
    default:
      return raiseUnreachable(option);
  }
}
